import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { CostOfInaction } from './components/CostOfInaction';
import { InsideLook } from './components/InsideLook';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { PricingCards } from './components/PricingCards';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
const testimonials = [{
  name: 'María G.',
  location: 'Córdoba',
  quote: 'Después de leer los primeros tomos empecé a comprender muchas reacciones que antes no entendía. Todo está explicado de forma muy clara.'
}, {
  name: 'Laura P.',
  location: 'Rosario',
  quote: 'Es mucho más completo de lo que esperaba. No son frases motivacionales, realmente aprendés cómo funciona la mente.'
}, {
  name: 'Gabriel S.',
  location: 'Buenos Aires',
  quote: 'La estructura hace que avances paso a paso. Sentís que recorrés un verdadero proceso de transformación.'
}];
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-paper font-body text-ink selection:bg-clay/20 selection:text-ink" data-id="element-0" data-mp="5yjetptzbev">
      <Hero data-id="element-1" data-mp="2zl3cxocsjc6w" />
      <SocialProof data-id="element-2" data-mp="2zllen0i82im7" />
      <PainPoints data-id="element-3" data-mp="2zm4wyibsb90r" />
      <CostOfInaction data-id="element-4" data-mp="2zmo5j8fjol24" />
      <InsideLook data-id="element-5" data-mp="2zng14j956ise" />
      <Tomos data-id="element-6" data-mp="33mf25srr5vek" />
      <Bonuses data-id="element-7" data-mp="33m5eibu6k0c1" />
      <Testimonials testimonials={testimonials} data-id="element-8" data-mp="33nq5jrhad155" />
      <PricingCards data-id="element-9" data-mp="33oi152avuyvf" />
      <FAQ data-id="element-10" data-mp="38l8hzruihyhw" />
      <Footer data-id="element-11" data-mp="38li7zffk45nl" />
    </main>;
}